 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const CarWithoutSliderContainer = () => {
  return (
    <>
      <Breadcrumbs title="Car Shop" url={routes.Home.CarDemo1} mainClass="car-breadcrumbs-section" />
      <GridView type="car" sectionClass="car-shop-section car-product-section" filterTagsClass="car-list-header" gridSize={3} view="image" carShow={9} />
    </>
  );
};

export default CarWithoutSliderContainer;
